<script setup lang="ts">
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'

withDefaults(
  defineProps<{
    darkMode?: boolean | 'auto'
  }>(),
  {
    darkMode: 'auto',
  },
)
</script>

<script lang="ts">
export default {}
</script>

<template>
  <OzBox
    :class="[
      'skeleton',
      // Remove animation and gradient if user prefers reduced motion
      'motion-reduce:animate-none',
      'motion-safe:bg-gradient-to-l',
      {
        'from-light-ui-200 via-light-ui-100 to-light-ui-200': darkMode === false,
        'from-dark-ui-200 via-dark-ui-100 to-dark-ui-200': darkMode === true,
        'from-light-ui-200 via-light-ui-100 to-light-ui-200 dark:from-dark-ui-200 dark:via-dark-ui-100 dark:to-dark-ui-200':
          darkMode === 'auto',
      },
    ]"
    :radius="8"
    :color="OzBoxColors.Secondary"
    :dark-mode="darkMode"
  />
</template>

<style lang="postcss" scoped>
.skeleton {
  background-size: 200% auto;
  animation: slide 1.5s linear infinite;
  will-change: background-position;
  @keyframes slide {
    to {
      background-position: -200% center;
    }
  }
}
</style>
